import Tooltip from '@mui/material/Tooltip';
import type { ReactElement } from 'react';

type DisabledReasonMessageTooltipWrapperProps = {
  children: ReactElement;
  isDisabled?: boolean;
  disabledReasonMessage?: string;
};

export const DisabledReasonMessageTooltipWrapper = ({
  children,
  isDisabled,
  disabledReasonMessage,
}: DisabledReasonMessageTooltipWrapperProps) => {
  if (isDisabled)
    return (
      <Tooltip placement="bottom" followCursor={true} title={disabledReasonMessage}>
        {children}
      </Tooltip>
    );

  return children;
};
